// mutations関数名の定数一覧
const MUTATION_TYPE = {
  SET_LOGIN_AUTH: 'set_login_auth', // ログイン認証情報の設定
  CLEAR_LOGIN_AUTH: 'clear_login_auth', // ログイン認証情報のクリア
  SET_LOGIN: 'set_login', // ログイン情報の設定
  CLEAR_LOGIN: 'clear_login', // ログイン情報のクリア
  SET_TOP: 'set_top', // TOP画面遷移時の設定
  CLEAR_TOP_AUTH: 'clear_top_auth', // TOP画面遷移時の認証有無のクリア
  CLEAR_TOP: 'clear_top', // TOP画面遷移時の設定削除
  LANGCHANGE: 'language', // 言語切り替え
  SET_DOWNLOAD_DETAIL: 'set_download_detail', // ダウンロード詳細情報設定
  CLEAR_DOWNLOAD_DETAIL: 'clear_download_detail', // ダウンロード詳細情報クリア
  SET_DOWNLOAD_NODATA: 'set_download_nodata', // ダウンロードデータ無しデータの設定
  CLEAR_DOWNLOAD_NODATA: 'clear_download_nodata', // ダウンロードデータ無しデータのクリア
  MENU_SET: 'menu_set', // メニュー情報設定
  CLEAR_HEADER: 'clear_header', // ヘッダー表示情報のクリア
  SET_OTHER: 'set_other', // 他画面情報の設定
} as const

type MUTATION_TYPE = typeof MUTATION_TYPE[keyof typeof MUTATION_TYPE]
export default MUTATION_TYPE
